import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { companyBySlug } from "../../data/content";
import { Eyebrow, Reveal } from "./motion";

const thread = [
  { num: "01", slug: "hapo-electronics", caption: "Manufactures the screen" },
  { num: "02", slug: "hapo-energy", caption: "Powers it" },
  { num: "03", slug: "hapo-cloud", caption: "Reads the audience with Vision AI" },
  { num: "04", slug: "hapo-media", caption: "Sells the advertising" },
  { num: "05", slug: "hapo-intelligence", caption: "Measures every audience, informs every decision" },
];

const positions = ["10%", "30%", "50%", "70%", "90%"];

export default function GoldenThread() {
  return (
    <section className="border-t border-white/10 bg-ink px-6 py-24 lg:px-12 lg:py-[160px]" aria-label="The Golden Thread">
      <Eyebrow>The Golden Thread</Eyebrow>
      <h2 className="mt-5 max-w-3xl text-4xl font-extrabold tracking-tighter text-white sm:text-5xl lg:text-6xl">
        One value chain, five companies.
      </h2>
      <p className="mt-6 max-w-2xl text-sm leading-loose text-smoke md:text-base">
        A screen is manufactured, powered, made intelligent, monetised and measured — all inside one group.
      </p>

      {/* Desktop: horizontal thread */}
      <div className="relative mt-24 hidden h-[300px] md:block">
        <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1200 300" preserveAspectRatio="none" aria-hidden="true">
          <motion.path
            d="M0 150 H1200"
            fill="none"
            stroke="#C79A45"
            strokeWidth="1.5"
            initial={{ pathLength: 0 }}
            whileInView={{ pathLength: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.8, ease: "easeInOut" }}
          />
        </svg>
        {thread.map((node, i) => {
          const c = companyBySlug(node.slug);
          return (
            <div
              key={node.slug}
              className="absolute top-1/2 w-56 -translate-x-1/2 -translate-y-1/2"
              style={{ left: positions[i] }}
            >
              <Reveal delay={0.3 + i * 0.35}>
                <Link to={`/companies/${node.slug}`} data-testid={`thread-${node.slug}`} className="group block text-center">
                  <span className="mx-auto block h-3 w-3 rounded-full bg-gold ring-8 ring-ink transition-transform duration-300 group-hover:scale-150" />
                  <span className="mt-6 block text-5xl font-extrabold tracking-tighter text-gold">{node.num}</span>
                  <span className="mt-2 block text-lg font-bold text-white transition-colors duration-300 group-hover:text-gold">
                    {c.name}
                  </span>
                  <span className="mt-2 block text-xs leading-relaxed text-smoke">{node.caption}</span>
                </Link>
              </Reveal>
            </div>
          );
        })}
      </div>

      {/* Mobile: vertical thread */}
      <div className="mt-14 border-l border-gold/40 pl-8 md:hidden">
        {thread.map((node) => {
          const c = companyBySlug(node.slug);
          return (
            <Reveal key={node.slug} className="relative py-6">
              <span className="absolute -left-[37px] top-8 h-3 w-3 rounded-full bg-gold" aria-hidden="true" />
              <Link to={`/companies/${node.slug}`} data-testid={`thread-mobile-${node.slug}`} className="block">
                <span className="text-4xl font-extrabold tracking-tighter text-gold">{node.num}</span>
                <span className="mt-1 block text-lg font-bold text-white">{c.name}</span>
                <span className="mt-1 block text-xs text-smoke">{node.caption}</span>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
